import { SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { formatShortDate } from '@duke-hq/djs';
import { Trans } from '@lingui/react/macro';
import { deriveEmployerStatus } from '@duke-hq/shared-constants/employer';
import { SingleField } from '@duke-hq/ui/components/SingleField/SingleField';
import { FormModalWrapper } from '@duke-hq/ui/components/Modals/FormModalWrapper';
import { trpcAdmin } from '../../../lib/trpcAdmin';
import { SectionCard } from '../components';
import { useCardEdit } from '../useCardEdit';
import { StatusEditForm } from './StatusEditForm';
import { EmployerStatusIndicator } from '../../components/employerStatusDisplay';
import { testIds } from '../../testIds';
import type { EmployerDetail } from '../types';

export function StatusCard({ employer }: { employer: EmployerDetail }): React.ReactElement {
  const { isOpen, onOpen, onClose, onSuccess, onError } = useCardEdit();
  const update = trpcAdmin.workPlacements.employers.updateEmployerStatus.useMutation({
    onSuccess,
    onError,
  });

  const status = deriveEmployerStatus(employer);

  return (
    <SectionCard
      title={<Trans>Status</Trans>}
      onEdit={onOpen}
      data-testid={testIds.drawerStatusSection}
    >
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <VStack alignItems="flex-start" gap={0}>
          <Text fontSize="xs" color="fg.muted" mt={2}>
            <Trans>Status</Trans>
          </Text>
          <EmployerStatusIndicator status={status} />
        </VStack>
        <SingleField
          name={<Trans>Agreement expiry</Trans>}
          value={formatShortDate(employer.agreementExpiresAt)}
        />
        <SingleField
          name={<Trans>Insurance expiry</Trans>}
          value={formatShortDate(employer.insuranceExpiresAt)}
        />
        <SingleField
          name={<Trans>Placement Capacity</Trans>}
          value={employer.placementCapacity != null ? String(employer.placementCapacity) : null}
        />
      </SimpleGrid>

      <FormModalWrapper
        isOpen={isOpen}
        onClose={onClose}
        modalContentHeight="auto"
        modalContent={
          <StatusEditForm
            employer={employer}
            onSave={(payload) => update.mutate({ employerId: employer.id, ...payload })}
            onCancel={onClose}
            isSaving={update.isPending}
          />
        }
      />
    </SectionCard>
  );
}
